import React, { useState } from 'react'
import bellicon from '../../../assets/images/bell-red-dot.svg';
import ReactEcharts from "echarts-for-react";
import SurveyListHeader from '../../../component/common/layout/SurveyListHeader';
import SurveyListSidebar from '../../../component/common/layout/SurveyListSidebar';
import Svg from '../../../component/common/Svg';
import { Link } from 'react-router-dom';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';


import DataTable from 'react-data-table-component';




const columns = [
    {
        name: 'Survey Name',
        selector: row => row.surveyname,
    },
    {
        name: 'Responses',
        cell: row => <><div className='text-center w-100'>{row.responses}</div></>,
        width: "220px",
    },
    {
        name: 'Completion',
        cell: row => <><div className='text-center w-100'>{row.percentage}</div></>,
        width: "220px",
    },
    {
        name: 'Status',
        cell: row => <div className='text-center w-100'><span className={"table-status " + row.status}>{row.status}</span></div>,
        width: "150px",
    },
    {
        name: 'Recent activity',
        cell: row => <><div className='text-center w-100'>{row.activity}</div></>,
        width: "170px",
    },

    {
        name: "",
        width: "60px",
        cell: row => <>
            <div className="dropdown table-dropdown">
                <button className="btn dropdown-tgl" type="button" id="viewoptions" data-bs-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <Svg name="action" />
                </button>
                <div className="dropdown-menu" aria-labelledby="viewoptions">
                    <a className="dropdown-item d-flex align-items-center">
                        <div className="icon-circle me-3">
                            <Svg name="Edit-Survey" />
                        </div>
                        <span className="dropdown-item" >Editrr Survey</span>
                    </a>
                    <a className="dropdown-item d-flex align-items-center" href="#0">
                        <div className="icon-circle me-3">
                            <Svg name="share" />
                        </div>
                        <span className="dropdown-item">Share Survey</span>
                    </a>
                    <a className="dropdown-item d-flex align-items-center" href="#0">
                        <div className="icon-circle me-3">
                            <Svg name="viewReport" />
                        </div>
                        <span className="dropdown-item">View Results</span>
                    </a>
                    <a className="dropdown-item d-flex align-items-center" href="#0">
                        <div className="icon-circle me-3">
                            <Svg name="duplicate" />
                        </div>
                        <span className="dropdown-item">Duplicate</span>
                    </a>
                    <a className="dropdown-item d-flex align-items-center">
                        <div className="icon-circle me-3">
                            <Svg name="delete" />
                        </div>
                        <span className="dropdown-item">Delete</span>
                    </a>
                </div>
            </div>
        </>

    }
];

const data = [
    {
        id: 1,
        surveyname: 'Network Maturity Assessment',
        responses: '45',
        percentage: '50 %',
        status: 'active',
        activity: '5 Minutes ago'
    },
    {
        id: 2,
        surveyname: 'IoT Network Assessment',
        responses: '45',
        percentage: '50 %',
        status: 'active',
        activity: '5 Minutes ago'
    },
    {
        id: 3,
        surveyname: 'Cloud Security Assessment',
        responses: '45',
        percentage: '50 %',
        status: 'active',
        activity: '5 Minutes ago'

    },
    {
        id: 4,
        surveyname: 'Internet Experience Assessment.',
        responses: '45',
        percentage: '50 %',
        status: 'active',
        activity: '5 Minutes ago'
    },
    {
        id: 5,
        surveyname: 'Sit sit sit erat et sed quam nunc. Morbi vulputate.',
        responses: '45',
        percentage: '50 %',
        status: 'active',
        activity: '5 Minutes ago'

    },
    {
        id: 6,
        surveyname: 'Media Networking',
        responses: '45',
        percentage: '50 %',
        status: 'active',
        activity: '5 Minutes ago'
    },
    {
        id: 7,
        surveyname: 'Network Maturity Assessment',
        responses: '45',
        percentage: '50 %',
        status: 'draft',
        activity: '5 Minutes ago'

    },
    {
        id: 8,
        surveyname: 'Network Maturity Assessment',
        responses: '45',
        percentage: '50 %',
        status: 'active',
        activity: '5 Minutes ago'
    },
    {
        id: 9,
        surveyname: 'Network Maturity Assessment',
        responses: '45',
        percentage: '50 %',
        status: 'draft',
        activity: '5 Minutes ago'
    },
    {
        id: 10,
        surveyname: 'Network Maturity Assessment',
        responses: '45',
        percentage: '50 %',
        status: 'active',
        activity: '5 Minutes ago'
    }
]

export default function Index() {

    const optionSurveys = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {},
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: ['Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5', 'Week 6', 'Week 7', 'Week 8', 'Week 9', 'Week 10'],
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {
                interval: 0,
                rotate: 40
            },
            splitLine: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            name: 'Responses',
            nameLocation: 'middle',
            nameGap: 40,
        },
        series: [

            {
                name: 'Survey Responses',
                barWidth: '40px',
                type: 'bar',
                stack: 'Survey',
                emphasis: {
                    focus: 'series'
                },
                data: [220, 182, 191, 234, 290, 330, 310, 191, 234, 290],

                itemStyle: {
                    color: '#E60000'
                },
            },
            {
                name: 'Completed Surveys',
                barWidth: '40px',
                type: 'bar',
                stack: 'Survey',
                emphasis: {
                    focus: 'series'
                },
                data: [120, 132, 101, 134, 90, 230, 210, 101, 134, 90],
                itemStyle: {
                    color: '#FFC453'
                },
            },
        ]
    };

    const [state, setState] = useState({
        start: moment().subtract(29, 'days'),
        end: moment(),
    });
    const { start, end } = state;
    const handleCallback = (start, end) => {
        setState({ start, end });
    };
    const label = start.format('DD/MM/YY') + ' - ' + end.format('DD/MM/YY');

    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <SurveyListHeader />
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <SurveyListSidebar />
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap'>
                            <div className="page-heading d-flex align-items-center justify-content-between">
                                <h1>Dashboard</h1>
                                <Link to="/build" type="button" className="btn btn-primary add-btn">
                                    <Svg name="plus" /> Create Survey </Link>
                            </div>
                            <div className="dashboard-cards-wraper row">
                                <div className="col-lg-8 mb__30">
                                    <div className="card dashboard-card min-100">
                                        <div className="dashboard-card-header d-md-flex justify-content-between align-items-center">
                                            <div className="left-wrap">
                                                <h3>Survey completion report</h3>
                                            </div>
                                            <div className="right-wrap d-flex align-items-center">
                                                <div className="drop-wrap">
                                                    <div className="dropdown table-dropdown ques-options">
                                                        <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <label>Select survey - </label>Security
                                                        </button>
                                                        <div className="dropdown-menu" aria-labelledby="languages">
                                                            <a className="dropdown-item" href="#">Network Survey</a>
                                                            <a className="dropdown-item" href="#">Security Survey</a>
                                                            <a className="dropdown-item" href="#">UCC Survey</a>
                                                            <a className="dropdown-item" href="#">Cloud Survey</a>
                                                            <a className="dropdown-item" href="#">Internet Experience</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='drop-wrap'>
                                                    <DateRangePicker
                                                        initialSettings={{
                                                            showDropdowns: true,
                                                            startDate: start.toDate(),
                                                            endDate: end.toDate(),
                                                            ranges: {
                                                                Today: [moment().toDate(), moment().toDate()],
                                                                Yesterday: [
                                                                    moment().subtract(1, 'days').toDate(),
                                                                    moment().subtract(1, 'days').toDate(),
                                                                ],
                                                                'Last 7 Days': [
                                                                    moment().subtract(6, 'days').toDate(),
                                                                    moment().toDate(),
                                                                ],
                                                                'Last 30 Days': [
                                                                    moment().subtract(29, 'days').toDate(),
                                                                    moment().toDate(),
                                                                ],
                                                                'This Month': [
                                                                    moment().startOf('month').toDate(),
                                                                    moment().endOf('month').toDate(),
                                                                ],
                                                                'Last Month': [
                                                                    moment().subtract(1, 'month').startOf('month').toDate(),
                                                                    moment().subtract(1, 'month').endOf('month').toDate(),
                                                                ],
                                                            },
                                                        }}
                                                        onCallback={handleCallback}
                                                    >
                                                        <div id="reportrange" className="date-range-picker">
                                                            <label>Date - </label>
                                                            <span>{label}</span>
                                                        </div>
                                                    </DateRangePicker>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="chart-wrapper">
                                                <ReactEcharts className='chart-height' option={optionSurveys} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb__30">
                                    <div className="card dashboard-card min-100">
                                        <div className="dashboard-card-header">
                                            <h3>Activity log</h3>
                                        </div>
                                        <div className="card-body">
                                            <ul className="notification-list">
                                                <li>
                                                    <p>“Employee engagment survey” got 2 new responses</p>
                                                    <div className='time'>1 min ago</div>
                                                </li>
                                                <li>
                                                    <p>15 new people visited the survey link</p>
                                                    <div className='time'>17 min ago</div>
                                                </li>
                                                <li>
                                                    <p> 14 new people completed the survey</p>
                                                    <div className='time'>17 min ago</div>
                                                </li>
                                                <li>
                                                    <p>12 new people visited the survey link</p>
                                                    <div className='time'>2h ago</div>
                                                </li>
                                                <li>
                                                    <p>12 new people visited the survey link</p>
                                                    <div className='time'>2h ago</div>
                                                </li>
                                                <li>
                                                    <p>12 new people visited the survey link</p>
                                                    <div className='time'>2h ago</div>
                                                </li>
                                            </ul>
                                            <div className="view-more text-center">
                                                <a href="#" className='read-more'>View more</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="card dashboard-card min-100 pb-1">
                                        <div className="dashboard-card-header d-md-flex justify-content-between align-items-center">
                                            <div className="left-wrap">
                                                <h3>Top 10 surveys</h3>
                                            </div>
                                            <div className="right-wrap d-flex align-items-center view-more">
                                                <a href="#" className='read-more'>View All</a>
                                            </div>
                                        </div>
                                        <div className="card-body dashboard-survey-list">
                                            <div className="data-table-wrap custom-data-table survey-table">
                                                <DataTable
                                                    // title="Movies"
                                                    columns={columns}
                                                    data={data}
                                                    // selectableRows
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <a className="table-name" data-bs-toggle="modal" data-bs-target="#duplicate-modal" aria-haspopup="true" aria-expanded="false">Test</a>


            </div>

        </>
    )
}
